import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
    <h1>Zásady zpracování osobních údajů MatikaMistr</h1>
    <p><strong>Účinnost od:</strong> 8.12.2025</p>
    <hr />
    <h2>1. Úvodní ustanovení</h2>
    <p>Vítejte na platformě <strong>MatikaMistr</strong>. Vaše soukromí a bezpečnost vašich dětí jsou pro nás prioritou. Tento dokument vysvětluje, jaká data sbíráme, proč to děláme a jaká máte práva.</p>
    <p>Správcem vašich osobních údajů je:</p>
    <p><strong>Šimon Schwarz</strong><br />E-mail: info@matikamistr.cz<br />(dále jen „Správce“ nebo „my“)</p>
    <hr />
    <h2>2. Ochrana dětí a mladistvých</h2>
    <p>Platforma je určena primárně pro žáky základních škol (5.–9. třída). Vzhledem k věku našich uživatelů uplatňujeme přísnější pravidla ochrany soukromí.</p>
    <ul>
      <li><strong>Registrace:</strong> Pokud je uživateli méně než 15 let, je k registraci a využívání služby nezbytný souhlas nebo přímá registrace zákonným zástupcem (rodičem).</li>
      <li><strong>Kontakt:</strong> Při registraci vyžadujeme kontaktní e-mail. U dětí mladších 15 let důrazně doporučujeme použít e-mail rodiče.</li>
      <li><strong>Práva rodičů:</strong> Rodiče mají právo kdykoliv požádat o přístup k účtu svého dítěte, kontrolu dat nebo jejich smazání.</li>
    </ul>
    <hr />
    <h2>3. Jaké údaje zpracováváme a proč</h2>
    <h3>3.1 Registrace a uživatelský profil</h3>
    <ul>
      <li>E-mailová adresa (slouží jako přihlašovací jméno a pro komunikaci)</li>
      <li>Přezdívka (Nickname) – doporučujeme neuvádět celé skutečné jméno</li>
      <li>Heslo (ukládáme pouze v šifrované podobě – hash)</li>
    </ul>
    <p><strong>Účel:</strong> Vytvoření účtu, přihlášení a správa uživatelského profilu.<br /><strong>Právní základ:</strong> Plnění smlouvy (poskytování služby dle Podmínek užití).<br /><strong>Doba uložení:</strong> Po dobu existence uživatelského účtu.</p>
    <h3>3.2 Výuka a adaptivní testování</h3>
    <ul>
      <li>Výsledky úloh a testů</li>
      <li>Statistiky postupu, získané body, historie chyb</li>
      <li>Interakce s platformou (čas strávený nad úlohou)</li>
    </ul>
    <p><strong>Účel:</strong> Základní funkcionalita platformy. Náš systém využívá tzv. <strong>funkční profilování</strong> – na základě výsledků žáka algoritmus automaticky vybírá další úlohy tak, aby odpovídaly jeho úrovni (adaptivní výuka). Nejedná se o marketingové profilování.<br /><strong>Právní základ:</strong> Plnění smlouvy (poskytování vzdělávacího obsahu).<br /><strong>Doba uložení:</strong> Po dobu existence uživatelského účtu.</p>
    <h3>3.3 Propojení se školou / třídou (volitelné)</h3>
    <p>Pokud se uživatel rozhodne připojit ke „třídě“ (např. na základě kódu od učitele), sdílíme vybraná data s daným učitelem.</p>
    <ul>
      <li>Identifikace žáka pro učitele (pouze Přezdívka, případně Křestní jméno a iniciála příjmení)</li>
      <li>Studijní výsledky a statistiky v rámci dané třídy</li>
    </ul>
    <p><strong>Účel:</strong> Umožnit učiteli sledovat pokrok žáka, zadávat úkoly a poskytovat zpětnou vazbu.<br /><strong>Právní základ:</strong> Oprávněný zájem uživatele (vzdělávání pod vedením učitele) a plnění funkce aplikace, kterou si uživatel aktivoval připojením ke třídě.<br /><strong>Doba uložení:</strong> Do odhlášení ze třídy nebo zrušení účtu.</p>
    <h3>3.4 Technická data a bezpečnost</h3>
    <ul>
      <li>IP adresa</li>
      <li>Technické logy (přístupy na server)</li>
      <li>Informace o zařízení (User-Agent)</li>
    </ul>
    <p><strong>Účel:</strong> Zajištění bezpečnosti serverů, ochrana před útoky (DDoS, brute-force) a technická diagnostika chyb.<br /><strong>Právní základ:</strong> Oprávněný zájem Správce na bezpečnosti služby.<br /><strong>Doba uložení:</strong> Serverové logy jsou uchovávány maximálně 30 dní, poté jsou automaticky přemazány.</p>
    <hr />
    <h2>4. Komu údaje předáváme</h2>
    <p>Vaše data neprodáváme. Přístup k nim mají pouze prověření partneři, kteří nám zajišťují technický chod aplikace:</p>
    <ol>
      <li><strong>Hosting a infrastruktura:</strong><br />Hetzner Online GmbH (Německo) – poskytovatel serverů. Data neopouští EU.</li>
      <li><strong>E-mailové služby:</strong><br />Brevo (Sendinblue SAS, Francie) nebo Resend (USA) – pro zasílání transakčních e-mailů (zapomenuté heslo, potvrzení registrace).<br /><em>Poznámka k USA:</em> Pokud jsou data předávána do USA (např. Resend), je ochrana zajištěna v souladu s rozhodnutím o odpovídající ochraně (Data Privacy Framework) nebo standardními smluvními doložkami.</li>
      <li><strong>Analytika (anonymizovaná):</strong><br />Google Analytics 4 – používáme pouze pro měření návštěvnosti. Data jsou agregovaná a neslouží k identifikaci jednotlivce ani k cílení reklamy.</li>
    </ol>
    <hr />
    <h2>5. Jak data chráníme</h2>
    <ul>
      <li><strong>Šifrování:</strong> Veškerá komunikace mezi vaším zařízením a našimi servery je šifrována protokolem HTTPS.</li>
      <li><strong>Hesla:</strong> Hesla neukládáme v čitelné podobě, ale jako hash (bcrypt/argon2), který nelze zpětně rozšifrovat.</li>
      <li><strong>Minimalizace:</strong> Učitelům zobrazujeme pouze nezbytné minimum údajů (např. pouze iniciálu příjmení).</li>
      <li><strong>Databáze:</strong> Data jsou uložena v zabezpečených databázových systémech s omezeným přístupem pouze pro administrátory.</li>
    </ul>
    <hr />
    <h2>6. Vaše práva (GDPR)</h2>
    <ol>
      <li><strong>Na přístup:</strong> Vědět, co o vás evidujeme.</li>
      <li><strong>Na opravu:</strong> Pokud máte v profilu chybu, můžete ji opravit v nastavení nebo nám napsat.</li>
      <li><strong>Na výmaz (být zapomenut):</strong> Můžete kdykoliv požádat o smazání celého účtu.</li>
      <li><strong>Na přenositelnost:</strong> Získat svá data ve strojově čitelném formátu.</li>
      <li><strong>Vznést námitku:</strong> Proti zpracování na základě oprávněného zájmu.</li>
    </ol>
    <p>Pro uplatnění práv nás kontaktujte na e-mailu uvedeném v úvodu. Odpovíme nejpozději do 30 dnů.</p>
    <hr />
    <h2>7. Závěrečná ustanovení</h2>
    <ul>
      <li><strong>Cookies:</strong> Informace o používání souborů cookies naleznete v samostatném dokumentu <a href="/cookies">Cookie Policy</a>.</li>
      <li><strong>Změny zásad:</strong> Tyto zásady můžeme v budoucnu upravit (např. kvůli změně legislativy). O zásadních změnách vás budeme informovat e-mailem.</li>
    </ul>
    <p><strong>Datum poslední aktualizace:</strong> 6.12.2025</p>
  </div>
  );
};

export default PrivacyPolicy;
